module.exports = __webpack_public_path__ + "img/gradient-bg.3ef65403.svg";